// EVENTS.VIEWS.APP.REPORTS.DEVICES

export const DEVICES = {
  PAGE_VISITED: 'devices_report-page_visited'
};
